import { MEDIA } from "@/lib/constants";

export default function BeliefBreak() {
    return (
        <section
            id="belief-break"
            data-testid="section-belief-break"
            className="relative bg-emerald-brand text-white overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-[0.10] pointer-events-none"
                style={{
                    backgroundImage: `url(${MEDIA.backgroundTexture})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    mixBlendMode: "screen",
                }}
            />
            <div className="absolute inset-0 grain pointer-events-none opacity-30" />
            <div className="relative max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 py-24 lg:py-32 text-center">
                <div className="reveal">
                    <div className="flex items-center justify-center gap-3 mb-6">
                        <span className="h-px w-10 bg-gold-brand" />
                        <span className="label-eyebrow">A verdade</span>
                        <span className="h-px w-10 bg-gold-brand" />
                    </div>
                    <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                        O problema nunca foi você.
                        <br />
                        Foi o
                        <span className="italic text-gold-brand"> método</span>.
                    </h2>
                </div>

                <div className="mt-10 space-y-6 reveal text-lg lg:text-xl text-white/85 leading-relaxed">
                    <p>
                        A escola tradicional ensinou você a{" "}
                        <strong>passar em prova</strong>, não a{" "}
                        <strong>falar</strong>.
                    </p>
                    <p>
                        Decorar listas de verbos irregulares,{" "}
                        <em>“present perfect continuous”</em>, regras que ninguém
                        usa numa conversa real.
                    </p>
                    <p>
                        Por isso seu cérebro trava: ele aprendeu inglês como
                        matéria, não como <strong>idioma vivo</strong>.
                    </p>
                </div>

                <div className="mt-12 reveal inline-block">
                    <div className="font-serif italic text-2xl sm:text-3xl text-gold-brand border-l-2 border-gold-brand pl-6 text-left max-w-xl">
                        Poliglotas não estudam mais. Eles estudam{" "}
                        <span className="not-italic font-bold">diferente</span>.
                    </div>
                </div>
            </div>
        </section>
    );
}
